import React, { useState, useEffect } from "react";

const HolidayForm = ({
  loading,
  closeModal,
  onSubmit,
  initialValues,
  errors: apiErrors = {}, 
}) => {
  const [formData, setFormData] = useState(initialValues);
  const [localErrors, setLocalErrors] = useState({});

  useEffect(() => {
    if (apiErrors && Object.keys(apiErrors).length > 0) {
      setLocalErrors(apiErrors);
    }
  }, [apiErrors]);

  const validateField = (name, value) => {
    let error = "";
    if (name === "occasion") {
      if (!value || value.trim() === "") {
        error = "Occasion is required";
      } else if (value.length > 50) {
        error = "Occasion cannot exceed 50 characters";
      }
    } else if (name === "date") {
      if (!value || value.trim() === "") {
        error = "Date is required";
      }
    }
    return error;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    const error = validateField(name, value);
    setLocalErrors((prev) => ({ ...prev, [name]: error }));
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    const occasionError = validateField("occasion", formData.occasion);
    const dateError = validateField("date", formData.date);

    if (occasionError || dateError) {
      setLocalErrors({ occasion: occasionError, date: dateError });
      return;
    }

    const submissionData = new FormData();
    submissionData.append("date", formData.date);
    submissionData.append("occasion", formData.occasion);

    onSubmit(submissionData);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4 font-poppins">
      <div>
        <label htmlFor="date" className="block text-sm font-medium dark:text-white text-gray-700">
          Date <span className="text-red-500">*</span>
        </label>
        <input
          type="date"
          id="date"
          name="date"
          value={formData.date}
          onChange={handleChange}
          className={`mt-1 dark:bg-black dark:text-white dark:border-gray-700 block w-full border rounded-md p-2 ${
            localErrors.date ? "border-red-500" : "border-gray-300"
          }`}
        />
        {localErrors.date && <p className="text-red-500 text-sm mt-1">{localErrors.date}</p>}
      </div>
        
      <div>
        <label htmlFor="occasion" className="block text-sm font-medium dark:text-white text-gray-700">
          Occasion <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          id="occasion"
          name="occasion"
          value={formData.occasion}
          onChange={handleChange}
          className={`mt-1 dark:bg-black dark:text-white dark:border-gray-700 block w-full border rounded-md p-2 ${
            localErrors.occasion ? "border-red-500" : "border-gray-300"
          }`}
        />
        {localErrors.occasion && <p className="text-red-500 text-sm mt-1">{localErrors.occasion}</p>}
      </div>

      <div className="flex justify-end items-center gap-2">
        <button
          type="button"
          onClick={closeModal}
          className="px-6 py-2 font-medium text-black hover:bg-gray-200 dark:hover:bg-gray-900 dark:bg-black dark:text-white dark:focus:outline-none border border-gray-300 rounded-md"
        >
          Cancel
        </button>
        <button
          type="submit"
          className="flex items-center gap-2 px-8 py-2 font-medium bg-blue-600 text-white rounded-md hover:bg-blue-700"
          disabled={loading || Object.values(localErrors).some(err => err)}
        >
          {initialValues.id ? "Update" : "Add"}
          {loading && (
            <svg
              className="animate-spin h-5 w-5 ml-2 text-white"
              viewBox="0 0 24 24"
            >
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
            </svg>
          )}
        </button>
      </div>
    </form>
  );
};

export default HolidayForm;
